import React, { Component } from "react";
import { Button, Input, Modal, Result } from "antd";
import { FormOutlined, SearchOutlined } from "@ant-design/icons";
import { stockOtodisService } from "../../services/otodisApi/StockOtodisService";

class SearchStockByStockUnit extends Component<any, any> {
  private initState!: any;

  constructor(props: any) {
    super(props);

    this.initState = {
      dealerCode: "",
      processing: false,
      searchStockUnitCode: "",
    };
    this.state = { ...this.initState };
  }

  onStringFieldChange = <T extends keyof Pick<any, "searchStockUnitCode">>(target: T, value: any) => {
    const currentState = { ...this.state };
    switch (target) {
      case "searchStockUnitCode":
        currentState.searchStockUnitCode = value;
        break;
    }
    this.setState({
      ...currentState,
    });
  };

  onClickBtnStockUnit = async () => {
    if (!this.state.searchStockUnitCode) {
      Modal.error({
        title: "error",
        content: "silakan isi kode stock unit",
      });
      return;
    }

    this.setState({
      processing: true,
    });

    stockOtodisService
      .getStock({
        dealerCode: this.state.dealerCode,
        stockUnitCode: this.state.searchStockUnitCode,
      })
      .then(async (value) => {
        this.setState({
          processing: false,
        });

        if (value.data.data[0].stock_status === "ACTIVE") {
          this.props.onFetchStockChosen(value.data.data[0]);
        } else {
          Modal.error({
            title: "error",
            content: "stock tidak dalam kondisi active",
          });
          return;
        }
      })
      .catch(async (reason) => {
        Modal.error({
          title: "error",
          content: "server menolak permintaan anda",
        });
        this.setState({
          processing: false,
        });
        return;
      });
  };

  async componentDidMount() {
    await this.promisedSetState({
      dealerCode: this.props.dealerCode,
    });
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
    if (this.props.dealerCode !== prevProps.dealerCode) {
      this.setState({
        dealerCode: this.props.dealerCode,
        searchStockUnitCode: "",
      });
    }
  }

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <Result
        icon={<FormOutlined />}
        title="Buat order berdasarkan kode stock unit"
        extra={
          <div>
            <Input
              value={this.state.searchStockUnitCode}
              onChange={(event) => this.onStringFieldChange("searchStockUnitCode", event.target.value)}
              placeholder="Kode Stock Unit"
              className={`search-input-form`}
            />
            <br />
            <Button loading={this.state.processing} type="primary" icon={<SearchOutlined />} onClick={(event) => this.onClickBtnStockUnit()}>
              Cari
            </Button>
          </div>
        }
      />
    );
  }
}

export default SearchStockByStockUnit;
